/**
 * Обёртка маршрута /settings/:tab — резолвит роль (canManage) из
 * /v1/platform/me и рендерит SettingsPage. Нужна, потому что Workspace
 * прокидывает canManage только в module-компонент, а deep-link на вкладку
 * идёт через page-проп (в обход module-резолва). Стартовая вкладка берётся
 * из URL самим SettingsPage.
 */
import { usePlatformMe } from "../../shared/api/usePlatformMe.js";
import { resolveDashboardKind } from "../../shared/nav/resolve-role.js";
import { SettingsPage } from "../rooms/SettingsPage.js";

export function SettingsRoute(): JSX.Element {
  const { data } = usePlatformMe();
  const kind = data ? resolveDashboardKind(data.actor.roles) : "guest";
  const canManage = kind === "owner" || kind === "manager";
  return <SettingsPage canManage={canManage} />;
}
